import { useCallback, useState } from 'react';

import QueueMonitoringService from '../services/queueMonitoringService';

export const useBFFQueueMonitoring = (
  queuesToMonit,
  voiceChannelsToMonit,
  agents
) => {
  const [queueMonitoringData, setQueueMonitoringData] = useState(null);
  const [queueMonitoringDataByQueue, setQueueMonitoringDataByQueue] =
    useState(null);

  const getQueueMonitoringData = useCallback(async () => {
    try {
      const params = {};

      if (queuesToMonit && queuesToMonit.length > 0) {
        params.queues = queuesToMonit;
      }

      if (voiceChannelsToMonit && voiceChannelsToMonit.length > 0) {
        params.voiceChannels = voiceChannelsToMonit;
      }

      if (agents && agents.length > 0) {
        params.agentCodes = agents.map((a) => a.agent_code || a);
      }

      const response = await QueueMonitoringService.getQueueMonitoringData(
        params
      );

      setQueueMonitoringData(response.data.data);
    } catch (error) {
      setQueueMonitoringData(null);
    }
  }, [queuesToMonit, voiceChannelsToMonit]);

  const getQueueMonitoringDataByQueue = useCallback(async () => {
    try {
      const params = {};

      if (queuesToMonit && queuesToMonit.length > 0) {
        params.queues = queuesToMonit;
      }

      if (voiceChannelsToMonit && voiceChannelsToMonit.length > 0) {
        params.voiceChannels = voiceChannelsToMonit;
      }

      if (agents && agents.length > 0) {
        params.agentCodes = agents.map((a) => a.agent_code || a);
      }

      console.log('getQueueMonitoringDataByQueue params:', params);

      const response =
        await QueueMonitoringService.getQueueMonitoringDataByQueue(params);

      setQueueMonitoringDataByQueue(response.data.data);
    } catch (error) {
      setQueueMonitoringDataByQueue(null);
    }
  }, [queuesToMonit, voiceChannelsToMonit]);

  return {
    queueMonitoringData,
    getQueueMonitoringData,
    getQueueMonitoringDataByQueue,
    queueMonitoringDataByQueue
  };
};
